<template>
  <div class="order-page">
    <div class="container">
      <search :perm="perm" @add="add" @updateFilters="updateFilters"/>
      <el-table :data="dataList" :header-row-class-name="'headerClass'"
                @expand-change="expandChange"
                :v-loading="loadingData" ref="orderDetail">
        <el-table-column type="expand">
          <template slot-scope="{row}">
            <div  style="padding: 20px 50px">
              <el-table :data="row.warehouseList" :header-row-class-name="'headerClass'">
                <el-table-column label="仓库名称" min-width="150" prop="name">
                </el-table-column>
                <el-table-column label="仓库编码" min-width="150" prop="code">
                </el-table-column>
                <el-table-column label="操作" prop="updateTime" width="300">
                  <template slot-scope="scope">
                    <des-btn :perm="perm.editWarehouse" @click="editWarehouse(scope.row, row)" icon="edit">编辑</des-btn>
                    <des-btn :perm="perm.delWarehouse" @click="deleteWarehouse(scope.row, row)" class="ml-10" icon="delete">删除
                    </des-btn>
                    <des-btn :perm="perm.queryDev" @click="queryDev(scope.row, row)" class="ml-10" custom icon="detail">查看温控设备</des-btn>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="物流中心名称" min-width="150" prop="name">
        </el-table-column>
        <el-table-column label="物流中心编码" min-width="150" prop="code">
        </el-table-column>
        <el-table-column label="物流中心地址" min-width="150" prop="logisticsDetail">
        </el-table-column>
        <el-table-column label="操作" prop="updateTime" width="250">
          <template slot-scope="scope">
            <des-btn :perm="perm.edit" @click="edit(scope.row)" icon="edit">编辑</des-btn>
            <des-btn :perm="perm.addWarehouse" @click="addWarehouse(scope.row)" icon="plus"  class="ml-10">添加仓库</des-btn>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page-right :show="showAddPart" @right-close="resetRightBox">
      <add-form :formItem="form" :show="showAddPart" @change="addChange"
                @close="resetRightBox"></add-form>
    </page-right>
    <page-right :show="showWarehouseAddPart" @right-close="resetRightBox">
      <warehouse-form :formItem="form" :currentItem="currentItem" :show="showWarehouseAddPart" @change="warehouseChange"
                      @close="resetRightBox"></warehouse-form>
    </page-right>
    <page-right :show="showDevPart" @right-close="resetRightBox" :css="{width: '900px'}">
      <dev-list :formItem="form" :currentItem="currentItem" :show="showDevPart" @change="warehouseChange"
                @close="resetRightBox"></dev-list>
    </page-right>
  </div>
</template>
<script>
  import Search from './search';
  import {BspLogistics, BspWarehouse} from '@/resources';
  import AddForm from './form';
  import WarehouseForm from './warehouse';
  import DevList from './dev-list';

  export default {
    components: {Search, AddForm, WarehouseForm, DevList},
    data() {
      return {
        loadingData: true,
        dataList: [],
        filters: {},
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: parseInt(window.localStorage.getItem('currentPageSize'), 10) || 10
        },
        currentItem: {},
        showAddPart: false,
        showWarehouseAddPart: false,
        showDevPart: false,
        form: {}
      };
    },
    computed: {
      perm() {
        return this.$route.meta.pagerPerm;
      }
    },
    mounted() {
      this.queryPager(1);
    },
    methods: {
      updateFilters(val) {
        Object.assign(this.filters, val);
        this.queryPager(1);
      },
      add() {
        this.form = {};
        this.showAddPart = true;
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        window.localStorage.setItem('currentPageSize', val);
        this.queryPager(1);
      },
      handleCurrentChange(val) {
        this.queryPager(val);
      },
      queryPager: function (pageNo) {
        this.pager.currentPage = pageNo;
        let param = Object.assign({}, {
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        }, this.filters);
        this.loadingData = true;
        BspLogistics.queryCurLogistics(param).then(res => {
          res.data.forEach(i => {
            i.warehouseList = [];
          });
          this.dataList = res.data;
          this.pager.count = res.data.count;
          this.loadingData = false;
        });
      },
      queryWarehouse(item) {
        let params = {
          logisticsCentreId: item.id
        };
        BspWarehouse.queryList(params).then(res => {
          item.warehouseList = res.data;
        });
      },
      expandChange(row, expand) {
        if (!expand) return;
        this.queryWarehouse(row);
      },
      resetRightBox() {
        this.showAddPart = false;
        this.showWarehouseAddPart = false;
        this.showDevPart = false;
        this.form = {};
      },
      addChange() {
        this.queryPager(this.pager.currentPage);
        this.resetRightBox();
      },
      warehouseChange(currentItem) {
        this.queryWarehouse(currentItem);
        this.resetRightBox();
      },
      addWarehouse(row) {
        this.currentItem = row;
        this.form = {};
        this.showWarehouseAddPart = true;
      },
      editWarehouse(row, currentItem) {
        this.currentItem = currentItem;
        this.form = row;
        this.showWarehouseAddPart = true;
      },
      deleteWarehouse(row, currentItem) {
        this.$confirm(`是否删除仓库"${row.name}"`, '', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          BspWarehouse.delete(row.id).then(() => {
            this.$notify.success({
              duration: 2000,
              message: '删除成功'
            });
            this.queryWarehouse(currentItem);
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '删除失败'
            });
          });
        });
      },
      edit(row) {
        this.form = row;
        this.showAddPart = true;
      },
      deleteRow(row) {
        this.$confirm(`是否删除物流中心"${row.name}"`, '', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          BspLogistics.delete([row.id]).then(() => {
            this.$notify.success({
              duration: 2000,
              message: '删除成功'
            });
            this.queryPager(this.pager.currentPage);
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '删除失败'
            });
          });
        });
      },
      queryDev(item) {
        this.currentItem = item;
        this.form = item;
        this.showDevPart = true;
      }
    }
  };
</script>
